import { useEffect } from 'react';

import getConfig from '../../util/config';
import getLogger from '../../util/logger';

const useGtagManualTracking = () => {
  const { google } = getConfig();
  const { gtag } = global;
  const logger = getLogger('manualGtag');

  // Initial setup
  useEffect(() => {
    if (gtag) {
      gtag('js', new Date());
      gtag('config', google.gtagId);
    }
  }, [gtag]);

  const onTrackPageView = data => {
    if (gtag) {
      gtag('js', new Date());
      gtag('event', 'page_view', data);
    } else {
      logger.warn('GTAG :: onTrackPageView - No Gtag', data);
    }
  };

  const onTrackEvent = ({ event, data }) => {
    if (gtag) {
      gtag('js', new Date());
      gtag('event', event, data);
    } else {
      logger.warn('GTAG :: onTrackEvent - No Gtag', event, data);
    }
  };

  return {
    onTrackPageView,
    onTrackEvent,
  };
};

export default useGtagManualTracking;
